import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './404.css'

export default function NoMatch() {
    const uselocation = useLocation();
    const url = uselocation.pathname;
    return (
        <main>
            <div className="page_not_found">
                <div> 
                    <Link to="https://www.lacnic.net/" title="LACNIC" >
                        <img src="/lacnic.svg" alt="LACNIC" title="LACNIC" width="200px" />
                    </Link>
                    <p><strong>404 error</strong></p>
                    <p>
                        No hemos encontrado
                        <code>{url}</code>
                        en nuestro servidor.
                    </p>
                </div>
            </div>
        </main>
    )
}
